import React, { useState } from "react";
import { Facebook, Link2, Check, Instagram, Download } from "lucide-react";
import { toast } from "sonner";

const copyText = async (text) => {
  try { await navigator.clipboard.writeText(text); }
  catch { const el = document.createElement("textarea"); el.value = text; document.body.appendChild(el); el.select(); document.execCommand("copy"); el.remove(); }
};

export default function ShareBar({ title, path, compact = false, testid = "share-bar", onFacebook = null, caption = "", cardUrl = "", onShare = null }) {
  const [copied, setCopied] = useState("");
  const url = `${window.location.origin}${path || window.location.pathname}`;
  const fb = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(title || "")}`;

  const flash = (key, msg) => { setCopied(key); toast.success(msg); setTimeout(() => setCopied(""), 2000); };
  const copy = async () => { await copyText(url); onShare?.("link"); flash("link", "Link copied — go spread the mischief! 🐾"); };
  const copyCaption = async () => { await copyText(caption); onShare?.("instagram"); flash("ig", "Instagram caption copied — paste it with the image 📸"); };
  const fbClick = (e) => { onShare?.("facebook"); onFacebook?.(e); };

  const btn = compact
    ? "w-12 h-12 rounded-full bg-white soft-shadow flex items-center justify-center hover:scale-105 transition-transform"
    : "inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-display font-bold soft-shadow hover:scale-105 transition-transform";

  return (
    <div className={`flex items-center gap-2 ${compact ? "" : "flex-wrap"}`} data-testid={testid}>
      {!compact && <span className="text-sm font-semibold text-[#19324A]/60 mr-1">Share the mischief:</span>}
      <a href={fb} target="_blank" rel="noopener noreferrer" onClick={fbClick} aria-label="Share on Facebook" title={onFacebook ? "Share on Facebook — get 5% off" : "Share on Facebook"} data-testid={`${testid}-facebook`}
        className={`${btn} ${compact ? "" : "bg-[#1877F2] text-white"}`}>
        <Facebook className={`w-5 h-5 ${compact ? "text-[#1877F2]" : ""}`} />{!compact && "Share on Facebook"}
      </a>
      {caption && (
        <button type="button" onClick={copyCaption} aria-label="Copy Instagram caption" title="Copy a ready-made Instagram caption" data-testid={`${testid}-instagram`}
          className={`${btn} ${compact ? "" : "text-white"}`} style={compact ? undefined : { background: "linear-gradient(45deg,#F58529,#DD2A7B,#8134AF)" }}>
          {copied === "ig" ? <Check className="w-5 h-5" /> : <Instagram className={`w-5 h-5 ${compact ? "text-[#DD2A7B]" : ""}`} />}{!compact && (copied === "ig" ? "Caption copied!" : "Instagram caption")}
        </button>
      )}
      {cardUrl && !compact && (
        <a href={cardUrl} download target="_blank" rel="noopener noreferrer" onClick={() => onShare?.("image")} aria-label="Download share image" title="Download the square share image for Instagram" data-testid={`${testid}-image`}
          className={`${btn} bg-[#FFD93D] text-[#19324A]`}>
          <Download className="w-5 h-5" /> Share image
        </a>
      )}
      <button type="button" onClick={copy} aria-label="Copy link" title="Copy link" data-testid={`${testid}-copy`}
        className={`${btn} ${compact ? "" : "bg-white text-[#19324A]"}`}>
        {copied === "link" ? <Check className="w-5 h-5 text-[#7ED957]" /> : <Link2 className={`w-5 h-5 ${compact ? "text-[#19324A]/60" : ""}`} />}{!compact && (copied === "link" ? "Copied!" : "Copy link")}
      </button>
    </div>
  );
}
